import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject critical <head> tags synchronously BEFORE React renders
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/37oXuGbWaJ1rd88SUAoKBe/11.png';
const GOOGLE_FONTS_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Fraunces:wght@500;600;700;800&display=swap';
function injectHeadTag(tag: string, attrs: Record<string, string>) {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => {
    if (k === 'crossorigin') el.setAttribute('crossorigin', v);else el.setAttribute(k, v);
  });
  document.head.appendChild(el);
}
// Preconnect — only the 2 required for Google Fonts
injectHeadTag('link', {
  rel: 'preconnect',
  href: 'https://fonts.googleapis.com'
});
injectHeadTag('link', {
  rel: 'preconnect',
  href: 'https://fonts.gstatic.com',
  crossorigin: 'anonymous'
});
// Preload LCP image with high priority
injectHeadTag('link', {
  rel: 'preload',
  as: 'image',
  href: LCP_IMAGE,
  fetchpriority: 'high'
});
// DNS prefetch for checkout domain
injectHeadTag('link', {
  rel: 'dns-prefetch',
  href: 'https://librofy.store'
});
// Meta description
injectHeadTag('meta', {
  name: 'description',
  content: 'MegaPack Hinchada, Cansada y Nerviosa — Reset Digestivo y Emocional. Sistema completo para mujeres argentinas que quieren recuperar su energía, reducir la hinchazón y calmar la ansiedad en 72 horas.'
});
// Load Google Fonts NON-BLOCKING
const fontLink = document.createElement('link');
fontLink.rel = 'preload';
fontLink.as = 'style';
fontLink.href = GOOGLE_FONTS_URL;
fontLink.onload = function (this: HTMLLinkElement) {
  this.rel = 'stylesheet';
};
document.head.appendChild(fontLink);
// Fallback for noscript
const noscriptEl = document.createElement('noscript');
noscriptEl.innerHTML = `<link rel="stylesheet" href="${GOOGLE_FONTS_URL}">`;
document.head.appendChild(noscriptEl);
render(<App data-id="element-404" />, document.getElementById('root'));